import { startTransition } from 'react';
import { ArrowRight, Clock, Shield, Zap } from 'lucide-react';
import { useLocalSession } from '@/hooks/useLocalSession';
import { useNavigate } from 'react-router-dom';

const reassurances = [
  { icon: Shield, text: "PDF parsed in your browser" },
  { icon: Zap, text: "Preview rows before export" },
  { icon: ArrowRight, text: "No credit card to get started" },
];

const CallToAction = () => {
  const isLoggedIn = useLocalSession();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    startTransition(() => navigate(isLoggedIn ? '/dashboard' : '/signin'));
  };

  return (
    <section className="py-20 md:py-28 relative overflow-hidden bg-white border-t border-[#1e0d01]/10">
      {/* Orange ambient glow */}
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 h-[400px] w-[600px] rounded-full bg-primary/8 blur-[120px]" />

      <div className="mx-auto max-w-[1160px] px-[30px] relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div
            className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-sm font-medium mb-6"
            style={{ color: "hsl(var(--primary))" }}
          >
            <Clock className="h-4 w-4" />
            Turn a bank statement PDF into a reviewable spreadsheet.
          </div>

          <h2
            className="font-medium mb-5 leading-tight"
            style={{
              fontSize: "clamp(2rem, 4.5vw, 3rem)",
              letterSpacing: "-2px",
              color: "#1e0d01",
            }}
          >
            Start converting your statements now.
            <br />
            <span style={{ color: "hsl(var(--primary))" }}>Review rows, then export Excel.</span>
          </h2>

          <p
            className="text-lg max-w-2xl mx-auto mb-8 leading-relaxed"
            style={{ color: "rgba(30,13,1,0.6)" }}
          >
            No copy-paste. No formulas. No re-keying rows. Upload your PDF
            and get a clean, structured Excel file. Free to try, no signup required.
          </p>

          <button
            onClick={handleGetStarted}
            className="group inline-flex items-center gap-3 rounded-full bg-primary text-white px-8 py-4 text-base font-semibold hover:scale-105 active:scale-95 transition-transform shadow-cta mb-8"
          >
            {isLoggedIn ? 'Go to Dashboard' : 'Convert your first PDF free'}
            <span className="w-6 h-6 overflow-hidden flex items-center justify-center">
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </button>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-3">
            {reassurances.map(({ icon: Icon, text }) => (
              <div key={text} className="flex items-center gap-2 text-sm" style={{ color: "rgba(30,13,1,0.5)" }}>
                <Icon className="h-4 w-4 text-primary" />
                {text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
